<template>
    <div class="report-container">
        <div class="page-header no-print">
            <div class="breadcrumb">ໜ້າຫຼັກ / ລາຍງານ / <span>ສະຖິຕິທົ່ວເມືອງ</span></div>
            <div class="header-content-wrapper">
                <div>
                    <h1>ບົດລາຍງານສະຖິຕິການສຶກສາທົ່ວເມືອງ</h1>
                    <p>ສະຫຼຸບຂໍ້ມູນນັກຮຽນ ແລະ ຄູສອນ ຂອງທຸກໂຮງຮຽນພາຍໃນເມືອງ</p>
                </div>
                <div class="header-actions">
                    <button class="btn-export-excel mr-2" @click="exportToExcel"><i class="fas fa-file-excel"></i> Export Excel</button>
                    <button class="btn-print" @click="printReport"><i class="fas fa-print"></i> ພິມລາຍງານ</button>
                </div>
            </div>
        </div>

        <div class="panel filter-panel no-print mb-4">
            <div class="panel-body">
                <div class="filter-grid">
                    <div class="form-group" style="max-width: 300px;">
                        <label>ເລືອກເມືອງ</label>
                        <select v-model="filters.districtId" @change="fetchReportData">
                            <option value="">-- ທຸກເມືອງ --</option>
                            <option v-for="item in districts" :key="item.value" :value="item.value">
                                {{ item.text }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group" style="max-width: 300px;">
                        <label>ສົກຮຽນ</label>
                        <select v-model="filters.academicYear" @change="fetchReportData">
                            <option v-for="year in academicYears" :key="year" :value="year">{{ year }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="report-content-paper">
            <!-- ສ່ວນຫົວຂໍ້ແບບທາງການ (ສະແດງສະເພາະເວລາພິມ) -->
            <div class="report-header-print only-print">
                <h2>ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ</h2>
                <h3>ສັນຕິພາບ ເອກະລາດ ປະຊາທິປະໄຕ ເອກະພາບ ວັດທະນາຖາວອນ</h3>
                <div class="report-title-section">
                    <h4>ບົດລາຍງານສະຖິຕິການສຶກສາທົ່ວເມືອງ</h4>
                    <p>ເມືອງ: {{ districts.find(d => d.value === filters.districtId)?.text || 'ທົ່ວເມືອງ' }} | ສົກຮຽນ: {{ filters.academicYear }}</p>
                </div>
            </div>

            <div class="kpi-grid mb-4">
                <div class="kpi-card border">
                    <div class="kpi-label">ໂຮງຮຽນທັງໝົດ</div>
                    <div class="kpi-value">{{ reportData.summary.totalSchools }}</div>
                    <div class="kpi-sub">ແຫ່ງ</div>
                </div>
                <div class="kpi-card border">
                    <div class="kpi-label">ນັກຮຽນທັງໝົດ</div>
                    <div class="kpi-value text-primary">{{ reportData.summary.totalStudents }}</div>
                    <div class="kpi-sub">ຍິງ: {{ reportData.summary.femaleStudents }}</div>
                </div>
                <div class="kpi-card border">
                    <div class="kpi-label">ຄູ-ພະນັກງານທັງໝົດ</div>
                    <div class="kpi-value text-success">{{ reportData.summary.totalStaff }}</div>
                    <div class="kpi-sub">ຍິງ: {{ reportData.summary.femaleStaff }}</div>
                </div>
            </div>

            <div class="panel mb-4">
                <div class="panel-head"><h3><i class="fas fa-school mr-2"></i> ສະຖິຕິແຍກຕາມໂຮງຮຽນ</h3></div>
                <div class="panel-body">
                    <table class="report-table">
                        <thead>
                            <tr>
                                <th>ລຳດັບ</th>
                                <th class="text-left">ຊື່ໂຮງຮຽນ</th>
                                <th>ນັກຮຽນ (ຍິງ)</th>
                                <th>ນັກຮຽນ (ຊາຍ)</th>
                                <th>ລວມນັກຮຽນ</th>
                                <th>ຄູສອນ (ລວມ)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in reportData.schoolStats" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td class="text-left">{{ item.school_id }} - {{ item.school_name }}</td>
                                <td>{{ item.femaleStudents }}</td>
                                <td>{{ item.maleStudents }}</td>
                                <td class="font-weight-bold">{{ item.totalStudents }}</td>
                                <td>{{ item.totalStaff }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- ສ່ວນລາຍເຊັນ (ສະແດງສະເພາະເວລາພິມ) -->
            <div class="report-footer-print only-print">
                <div class="signature-wrapper">
                    <div class="signature-column">
                        <p>ທີ່ ............................, ວັນທີ ....../....../......</p>
                        <p class="signature-title">ວິຊາການເມືອງ</p>
                        <div class="signature-space"></div>
                        <p>(......................................................)</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/utils/api'; // Assuming api.js is in '@/utils'

export default {
    name: 'DistrictReportPage',
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user-info') || '{}'),
            academicYears: [],
            districts: [],
            filters: { academicYear: '', districtId: '' },
            reportData: {
                summary: { totalSchools: 0, totalStudents: 0, femaleStudents: 0, totalStaff: 0, femaleStaff: 0 },
                schoolStats: []
            }
        };
    },
    mounted() {
        this.filters.districtId = this.user.district_id || '';
        this.generateAcademicYears();
        this.fetchDistricts();
        this.fetchReportData();
    },
    methods: {
        async fetchDistricts() {
            try {
                // ດຶງລາຍຊື່ເມືອງທັງໝົດໃນແຂວງຂອງຜູ້ໃຊ້
                const provId = this.user.prov_id || '01';
                const res = await api.get(`/getItemsCondition/district/district_name_lao/district_id/prov_id/${provId}`);
                if (res.data) {
                    this.districts = res.data;
                }
            } catch (e) {
                console.error('Fetch districts error:', e);
            }
        },
        generateAcademicYears() {
            const startYear = new Date().getMonth() >= 6 ? new Date().getFullYear() : new Date().getFullYear() - 1;
            for (let i = 0; i < 10; i++) {
                this.academicYears.push(`${startYear - i}-${startYear - i + 1}`);
            }
            this.filters.academicYear = this.academicYears[0];
        },
        async fetchReportData() {
            try {
                const res = await api.get('/reports/district-summary', {
                    params: { district_id: this.filters.districtId, year: this.filters.academicYear }
                });
                if (res.data.code === 1) this.reportData = res.data.data;
            } catch (e) {
                console.error(e);
            }
        },
        printReport() {
            window.print();
        },
        async exportToExcel() {
            // ໂຫຼດ Library XLSX ແບບ Dynamic ເພື່ອຫຼຸດຜ່ອນຂະໜາດໄຟລ໌ເບື້ອງຕົ້ນ
            const XLSX = await import('xlsx');

            const dataToExport = this.reportData.schoolStats.map((item, index) => ({
                'ລຳດັບ': index + 1,
                'ລະຫັດໂຮງຮຽນ': item.school_id,
                'ຊື່ໂຮງຮຽນ': item.school_name,
                'ນັກຮຽນ (ຍິງ)': item.femaleStudents,
                'ນັກຮຽນ (ຊາຍ)': item.maleStudents,
                'ລວມນັກຮຽນ': item.totalStudents,
                'ຄູສອນ (ລວມ)': item.totalStaff,
                'ຄູສອນ (ຍິງ)': item.femaleStaff // ເພີ່ມຄູສອນຍິງ
            }));

            const worksheet = XLSX.utils.json_to_sheet(dataToExport);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'District Report');

            // ສ້າງຊື່ໄຟລ໌ຕາມສົກຮຽນ ແລະ ເມືອງ
            const districtName = this.districts.find(d => d.value === this.filters.districtId)?.text || 'ທົ່ວເມືອງ';
            const fileName = `ລາຍງານສະຖິຕິ_${districtName}_${this.filters.academicYear}.xlsx`;

            XLSX.writeFile(workbook, fileName);
        }
    }
};
</script>

<style scoped>
.report-container { padding: 20px; }
.header-actions { display: flex; gap: 10px; }
.filter-grid { display: flex; gap: 20px; flex-wrap: wrap; }
.btn-print { background: var(--lao); color: white; border: none; padding: 10px 20px; border-radius: 8px; cursor: pointer; }
.btn-export-excel {
    background: #107c10; /* ສີຂຽວຂອງ Excel */
    color: white; border: none; padding: 10px 20px; border-radius: 8px; cursor: pointer;
    font-weight: 600;
}
.report-table { width: 100%; border-collapse: collapse; }
.report-table th, .report-table td { border: 1px solid #e2e8f0; padding: 12px; text-align: center; }
.text-left { text-align: left !important; }

.only-print { display: none; }

.report-header-print { text-align: center; margin-bottom: 30px; }
.report-footer-print { margin-top: 40px; }
.signature-wrapper { display: flex; justify-content: flex-end; padding-right: 50px; }
.signature-column { text-align: center; }
.signature-title { font-weight: 700; margin-top: 10px; }
.signature-space { height: 80px; }
.report-title-section { margin-top: 20px; border-top: 2px solid #000; padding-top: 10px; }

@media print {
    .no-print { display: none !important; }
    .only-print { display: block !important; }
    .report-container { padding: 0; }
    .panel { border: none !important; box-shadow: none !important; }
    .kpi-card { border: 1px solid #000 !important; }
    .report-table th { background: #eee !important; -webkit-print-color-adjust: exact; }
}
</style>